module.exports = __webpack_public_path__ + "img/mlxy.0a518c8f.png";